export default {
  back: {
    id: 'insurance_add_to_cart_page_back',
    defaultMessage: 'Back',
  },
  skipProtection: {
    id: 'insurance_add_to_cart_page_skip',
    defaultMessage: 'Skip protection',
  },
  addProtection: {
    id: 'insurance_add_to_cart_page_add',
    defaultMessage: 'Add protection',
  },
  compliancyError: {
    id: 'trutpack_cgv_error',
    defaultMessage: 'Thanks for accepting the general buying conditions.',
  },
}
